<template>
    <Card >
      <AjaxForm route="paymentType/add">
        <div class="row">
          <div class="col-12 col-sm-12 col-md-6">
            <CustomInput placeholder="عنوان..."
                         label="عنوان"
                         type="text"
                         name="title"></CustomInput>
          </div>
          <div class="col-12 col-sm-12 col-md-6">
            <CustomInput placeholder="تعداد روز..."
                         label="تعداد روز"
                         type="number"
                         name="n_day"></CustomInput>
          </div>
          <div class="col-12 col-sm-12 col-md-6">
            <CustomInput placeholder="توضیحات..."
                         label="توضیحات"
                         type="textarea"
                         name="description"></CustomInput>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-10 col-sm-8 col-md-5 mx-auto">
            <button class="btn btn-info btn-block">ثبت اطلاعات</button>
          </div>
        </div>
      </AjaxForm>
    </Card>
</template>

<script>
import MasterLayout from "@/components/MasterLayout";
import Card from "@/components/forms/Card";
import AjaxForm from "@/components/forms/AjaxForm";
import CustomInput from "@/components/CustomInput";
import {mapActions} from "vuex";
export default {
  name: "PaymentTypeAdd",
  components: {CustomInput, AjaxForm, Card, MasterLayout},
  async mounted()
  {
    this.setPageTitle('افزودن نوع پرداخت');
    this.setShowHead(true);
  },
  methods: {
    ...mapActions('app', {
      setPageTitle: 'setPageTitle',
      setPageLoading: 'setPageLoading',
      setShowHead: 'setShowHead'
    }),
  }
}
</script>

<style scoped>

</style>